import { Modal } from '@/components/Modal';

import { ModalItem } from './ModalItem';

import type { ItineraryProduct } from '@/types/products';

interface RoomUpgradeModalProps {
  showModal: boolean;
  closeModal: () => void;
  rooms: ItineraryProduct[];
}

export function RoomUpgradeModal({ showModal, closeModal, rooms }: RoomUpgradeModalProps) {
  return (
    <Modal show={showModal} onClose={closeModal} title="Perhaps these room upgrades are for you:" fullwidth>
      {rooms.map((room) => (
        <ModalItem key={room.id} roomProduct={room} />
      ))}
    </Modal>
  );
}
